/**
 * Format the cell value as either dashes or two decimals
 *
 * @param num input number
 * @returns dashes or two digit number
 */
export const formatCellValue = (num: number): string =>
  num === null || num === 0 ? '--' : num.toFixed(2);
